import React from 'react';

export const FileIcon: React.FC = () => (
	<svg width='1.8rem' height='2.3rem' viewBox='0 0 18 23' fill='none' xmlns='http://www.w3.org/2000/svg'>
		<path d='M10.625 1H1V22H16.75V7.125M10.625 1L16.75 7.125M10.625 1V7.125H16.75' stroke='currentColor' strokeWidth='1.5' />
		<path d='M3.625 14.5H14.125M3.625 18.5H9.3125' stroke='currentColor' strokeWidth='1.5' />
	</svg>
);
